import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pages-pda',
  templateUrl: './pages-pda.component.html',
  styles: [
  ]
})

export class PagesPdaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
